import WithRender from "../../templates/layouts/layoutPersonalization.html";

export default WithRender({});
